export enum PediatricTraumaScoreConstants {
  SET_TOTAL_SCORE = 'pediatricTraumaScore/SET_TOTAL_SCORE',
  SET_SIZE = 'pediatricTraumaScore/SET_SIZE',
  SET_AIRWAY = 'pediatricTraumaScore/SET_AIRWAY',
  SET_SYSBP = 'pediatricTraumaScore/SET_SYSBP',
  SET_CNS = 'pediatricTraumaScore/SET_CNS',
  SET_SKELETAL_INJURY = 'pediatricTraumaScore/SET_SKELETAL_INJURY',
  SET_OPEN_WOUNDS = 'pediatricTraumaScore/SET_OPEN_WOUNDS',
  SET_PTS_DATA = 'pediatricTraumaScore/SET_PTS_DATA',
  RESET_PTS_DATA = 'pediatricTraumaScore/RESET_PTS_DATA',
  SAVE_PTS_DATA = 'pediatricTraumaScore/SAVE_PTS_DATA',
}
